import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"max-width":"500px"},
  class: "m-auto community-policing-editor"
}

import {BTab, BTabs} from "./BTabs";
import DeleteReport from "@/components/CommunityPolicingEditor/DeleteReport.vue";
import ZeroReport from "@/components/CommunityPolicingEditor/ZeroReport.vue";
import {SystemAlerts} from "./Misc";
import { SelectEntryType } from "@/types";
import { ref } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'CommunityPolicingWebEntry',
  props: {
    title: {},
    url: {},
    allowZeroReport: { type: Boolean },
    allowDeleteReport: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const tabs = ref<BTab[]>([] as BTab[]);

if (props.allowZeroReport) {
    tabs.value.push({id: SelectEntryType.Zero, name: "Zero Report", selected: true, component: ZeroReport});
}

if (props.allowDeleteReport) {
    tabs.value.push({id: SelectEntryType.Delete, name: "Delete Report", selected: false, component: DeleteReport});
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "text-center mb-4" }, "Community Policing Editor", -1)),
      _createVNode(_unref(BTabs), {
        modelValue: tabs.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tabs).value = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(_unref(SystemAlerts))
  ], 64))
}
}

})